import React from 'react'
import file from '../../assets/pdfFile.svg'
import { Wrapper, Name, Image } from './styled'

const CardFileRecord = ({
    name = 'file',
    onClick,
}) => {

    return (
        <Wrapper
            onClick={onClick}
        >
            <Image
                src={file}
                alt={name}
            />
            <Name>{name}</Name>
        </Wrapper>
    )
}

export default CardFileRecord
